<template>
  <div class="navwrap">
    <div class="nav detailNav">
      <div class="navBox">
        <div>
          <div class="navImg">
            <a :href='host.sgsonlineUrl'>
              <img src="./../../assets/images/portal/logo.png" alt="第三方认证检测机构" />
            </a>
          </div>
          <div class="navList">
            <ul class="mainNav">
              <li>
                <a :href='host.sgsonlineUrl'>首页</a>
              </li>
              <li id="serviceHome">
                <span>我们的服务</span>
                <div class="dragAngel"></div>
                <div class="allNav clearfix" id='serviceNav'></div>
              </li>
              <li id='tradeHome'>
                <span>您的行业</span>
                <div class="dragAngel"></div>
                <div class="allNav" id='tradeNav'></div>
              </li>
              <li class="nav_first--li">
                <a :href='host.sgsonlineUrl + "/information"'>资源中心</a>
                <div class="dragAngel"></div>
                <dl class="nav_second">
                  <dd v-for='(item, index) of informations' :key='index'>
                    <a :href="host.sgsonlineUrl + '/information?type=' + item.id">{{ item.name }}</a>
                  </dd>
                  <dd>
                    <a :href='host.sgsonlineUrl + "/files"'>资料下载</a>
                  </dd>
                </dl>
              </li>
              <li class="nav_first--li">
                <a :href='host.sgsonlineUrl + "/overview/aboutSGS"'>关于SGS</a>
                <div class="dragAngel"></div>
                <dl class="nav_second">
                  <dd>
                    <a :href='host.sgsonlineUrl + "/overview/aboutSGS"'>SGS简介</a>
                  </dd>
                </dl>
              </li>
              <li>
                <a :href='host.sgsonlineUrl + "/baojia?spm=EJHxGX9b.M3nTPXTW..."'>业务咨询</a>
              </li>
              <li>
                <a :href='host.memberUrl + "/questionnaire/step1"' target="_blank">快速报价</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="navSearchBox">
          <button @click="handleSearch">
            <i class="navSearchIconIcon"></i>
          </button>
          <input type="text" class="navSearch placeholder" maxlength="100" v-model="inputVal" @input='handleInput'
            @keydown.enter="handleSearch">
          <div class="hotKeyword" v-if='!inputVal'>
            <a v-for="(item, index) of hotWords" :key='index' :href='host.sgsonlineUrl + "/search?q=" + item.name'>{{
            item.name }}</a>
          </div>
          <div class="linkageWord" v-if='relevances.length'>
            <ul>
              <li v-for='(item, index) of relevances' :key='index'>
                <a :href='host.sgsonlineUrl + "/search?q=" + item.keyword' v-html="item.title"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchHotWord, qryTitle, qryNavi } from 'src/request/portal'
import { host } from 'src/config'
import $ from 'jquery'
import { Debounce } from 'src/utils'

export default {
  name: 'PortalNavigation',
  props: {
    env: {
      type: String,
      default: 'local',
    },
  },
  data() {
    return {
      hotWords: [],
      inputVal: '',
      relevances: [],
      host: host(this.env),
      services: [],
      trades: [],
      informations: [],
    }
  },
  methods: {
    handleSearch() {
      window.location.href = `${this.host.sgsonlineUrl}/search?q=${this.inputVal}`
    },
    handleInput(event) {
      if (this.inputVal) {
        qryTitle(
          { keyword: this.inputVal, pageNum: 1, pageRow: 6 },
          this.host.nodeUrl
        ).then((res) => {
          if (res) this.relevances = res.data.items
        })
      } else {
        this.relevances = []
      }
    },
    renderNavicationInner(data, boxId, path) {
      const ticViewUrl = this.host.sgsonlineUrl
      const that = this
      var mainDom = '<div class="main">',
        sideDom = '<ul class="side">'
      data.forEach(function (v1, index) {
        if (!index) {
          sideDom +=
            '<li class="active"><a data-id="' +
            v1.id +
            '" href="' +
            ticViewUrl +
            path +
            v1.alias +
            '">' +
            v1.name +
            '</a></li>'
        } else {
          sideDom +=
            '<li><a href="' +
            ticViewUrl +
            path +
            v1.alias +
            '">' +
            v1.name +
            '</a></li>'
        }
      })
      sideDom += '</ul>'
      data.forEach(function (v1, index) {
        if (!index) {
          mainDom += '<div class="list clearfix active">'
        } else {
          mainDom += '<div class="list clearfix">'
        }
        if (v1.lstSub && v1.lstSub.length >= 5) {
          mainDom += '<div class="second"><ul>'
          v1.lstSub.forEach(function (v2, index2) {
            if (!index2) {
              mainDom +=
                '<li style="display: list-item;" class="active"><a href="javascript:void(0);" data-id="' +
                v2.id +
                '" data-link="' +
                path +
                v1.alias +
                '/#/' +
                v2.id +
                '">' +
                v2.name +
                '</a></li>'
            } else {
              mainDom +=
                '<li><a href="javascript:void(0);" data-id="' +
                v2.id +
                '" data-link="' +
                path +
                v1.alias +
                '/#/' +
                v2.id +
                '">' +
                v2.name +
                '</a></li>'
            }
          })
          mainDom += '</ul></div>'
          mainDom += '<div class="secondList">'
          mainDom += '<div class="clearfix">'
          mainDom += '<ul class="secondListLi">'
          v1.lstSub.forEach(function (v2, index2) {
            // 3级菜单start
            if (!index2) {
              mainDom += '<li style="display: list-item;">'
            } else {
              mainDom += '<li>'
            }
            mainDom += '<div class="main-list2 clearfix">'
            v2.lstNavi &&
              v2.lstNavi.forEach(function (v3, index3) {
                if (v3.showType === 1) {
                  mainDom += '<p class="cleafix">' + v3.showName + '</p>'
                }
                if (v3.showType === 2) {
                  mainDom +=
                    '<dd>' +
                    '<a href="' +
                    ticViewUrl +
                    v3.linkUrl +
                    '" data-collectCode="' +
                    v3.collectCode +
                    '"  data-id="' +
                    v3.catalogId +
                    '">' +
                    v3.showName +
                    '</a>'
                  if (v3.isHot) mainDom += '<i></i>' // 是否热门
                  mainDom += '</dd>'
                }
              })
            mainDom += '</div>'
            // 3级菜单end
            // 广告start
            mainDom +=
              '<div class="ads clearfix"><div class="moreService"><a href="' +
              ticViewUrl +
              '/service/' +
              v1.alias +
              '/service" class="moreServiceA">查看更多服务<i></i></a></div>'
            mainDom += '<ul>'
            v2.lstNavi &&
              v2.lstNavi.forEach(function (v3, index3) {
                if (v3.showType === 3) {
                  mainDom +=
                    '<li>' +
                    '<a href="' +
                    ticViewUrl +
                    v3.linkUrl +
                    '" data-collectCode="' +
                    v3.collectCode +
                    '"  data-id="' +
                    v3.catalogId +
                    '">' +
                    '<img src="' +
                    v3.imgUrl +
                    '">' +
                    '</a>' +
                    '<div class="info">' +
                    '<a href="' +
                    ticViewUrl +
                    v3.linkUrl +
                    '" data-collectCode="' +
                    v3.collectCode +
                    '"  data-id="' +
                    v3.catalogId +
                    '">' +
                    '<h3 title="' +
                    v3.showName +
                    '">' +
                    v3.showName +
                    '</h3>' +
                    '<p title="' +
                    v3.showSummary +
                    '">' +
                    v3.showSummary +
                    '</p>' +
                    '</a>'
                  if (v3.isBuy) {
                    mainDom +=
                      '<em data-id="' +
                      v2.id +
                      '" data-link="' +
                      v3.buyUrl +
                      '">立即订购</em>'
                  } else {
                    mainDom += '<button class="imBtn">在线咨询</button>'
                  }
                  mainDom += '</div>' + '</li>'
                }
              })
            mainDom += '</ul></div>'
            // 广告end
            mainDom += '</li>'
          })
          mainDom += '</ul>'
          mainDom += '</div>'
          mainDom += '</div>'
        } else {
          mainDom += '<div class="main-list">'
          v1.lstSub &&
            v1.lstSub.forEach(function (v2, index3) {
              mainDom += '<dl class="clearfix">'
              // v1.lstSub && v1.lstSub.forEach(function (v2, index3) {
              // 2级start
              mainDom +=
                '<dt>' +
                '<span>·</span>' +
                '<a href="javascript:void(0);" data-id="' +
                v2.id +
                '" data-link="' +
                path +
                v1.alias +
                '/#/' +
                v2.id +
                '">' +
                v2.name +
                '</a>' +
                '</dt>'
              // 2级end
              // 3级start
              v2.lstNavi &&
                v2.lstNavi.forEach(function (v3, index3) {
                  if (v3.showType === 2) {
                    mainDom +=
                      '<dd>' +
                      '<a href="' +
                      ticViewUrl +
                      v3.linkUrl +
                      '" data-collectCode="' +
                      v3.collectCode +
                      '"  data-id="' +
                      v3.catalogId +
                      '">' +
                      v3.showName +
                      '</a>'
                    if (v3.isHot) mainDom += '<i></i>' // 是否热门
                    mainDom += '</dd>'
                  }
                })
              // 3级end
              // })
              mainDom += '</dl>'
            })
          // 广告start
          mainDom += '<div class="ads">'
          mainDom +=
            '<div class="moreService">' +
            '<a href="' +
            ticViewUrl +
            '/service/' +
            v1.alias +
            '/service">查看更多服务<i></i></a>' +
            '</div>'
          mainDom += '<ul>'
          v1.lstSub &&
            v1.lstSub.forEach(function (v2, index3) {
              v2.lstNavi &&
                v2.lstNavi.forEach(function (v3, index3) {
                  if (v3.showType === 3) {
                    mainDom +=
                      '<li>' +
                      '<a href="' +
                      ticViewUrl +
                      v3.linkUrl +
                      '" data-collectCode="' +
                      v3.collectCode +
                      '"  data-id="' +
                      v3.catalogId +
                      '">' +
                      '<img src="' +
                      v3.imgUrl +
                      '">' +
                      '</a>' +
                      '<div class="info">' +
                      '<a href="' +
                      ticViewUrl +
                      v3.linkUrl +
                      '" data-collectCode="' +
                      v3.collectCode +
                      '"  data-id="' +
                      v3.catalogId +
                      '">' +
                      '<h3 title="' +
                      v3.showName +
                      '">' +
                      v3.showName +
                      '</h3>' +
                      '<p title="' +
                      v3.showSummary +
                      '">' +
                      v3.showSummary +
                      '</p>' +
                      '</a>'
                    if (v3.isBuy) {
                      mainDom +=
                        '<em data-id="' +
                        v2.id +
                        '" data-link="' +
                        v3.buyUrl +
                        '">立即订购</em>'
                    } else {
                      mainDom += '<button class="imBtn">在线咨询</button>'
                    }
                    mainDom += '</div>' + '</li>'
                  }
                })
            })
          mainDom += '</ul>'
          mainDom += '</div>'
          // 广告end
          mainDom += '</div>'
        }
        mainDom += '</div>'
      })
      mainDom += '</div>'
      boxId.html(sideDom + mainDom)
      setTimeout(function () {
        that.asyncBuildEvent()
      }, 100)
    },
    asyncBuildEvent() {
      const ticViewUrl = this.host.sgsonlineUrl
      var tradeNav = $('#tradeNav')
      tradeNav.on('mouseenter', '.side li', function () {
        var index = $(this).index()
        tradeNav
          .find('.main .list')
          .eq(index)
          .addClass('active')
          .siblings()
          .removeClass('active')
        $(this).addClass('active').siblings().removeClass('active')
      })
      $('#tradeHome').hover(
        function () {
          tradeNav.show()
          $(this).find('.dragAngel').show()
        },
        function () {
          tradeNav.hide()
          $(this).find('.dragAngel').hide()
        }
      )
      tradeNav.on('mouseenter', '.second li', function () {
        var index = $(this).index()
        $(this)
          .closest('.list')
          .find('.secondListLi > li')
          .eq(index)
          .show()
          .siblings()
          .hide()
        $(this).addClass('active').siblings().removeClass('active')
      })

      var serviceNav = $('#serviceNav')
      serviceNav.on('mouseenter', '.side li', function () {
        var index = $(this).index()
        serviceNav
          .find('.main .list')
          .eq(index)
          .addClass('active')
          .siblings()
          .removeClass('active')
        $(this).addClass('active').siblings().removeClass('active')
      })

      // B类二级菜单
      serviceNav.on('mouseenter', '.second li', function () {
        var index = $(this).index()
        $(this)
          .closest('.list')
          .find('.secondListLi > li')
          .eq(index)
          .show()
          .siblings()
          .hide()
        $(this).addClass('active').siblings().removeClass('active')
      })
      $('#serviceHome').hover(
        function () {
          serviceNav.show()
          $(this).find('.dragAngel').show()
        },
        function () {
          serviceNav.hide()
          $(this).find('.dragAngel').hide()
        }
      )
      // 新增二级下拉查单
      $('.nav_first--li').hover(
        function () {
          $(this).find('.dragAngel').show()
          $(this).find('.nav_second').show()
        },
        function () {
          $(this).find('.dragAngel').hide()
          $(this).find('.nav_second').hide()
        }
      )
      $('.mainNav').on('click', 'em', function () {
        var buyUrl = $(this).data('link')
        window.location.href = buyUrl
      })

      $('.mainNav')
        .off('click')
        .on('click', '.imBtn', function () {
          $.ajax({
            type: 'POST',
            url: ticViewUrl + 'IMtool',
            data: {
              paraName: 'CHAT_SET',
            },
            headers: {
              frontUrl: window.location.href,
            },
            success: function (res) {
              var isLeadoo = false
              var isKf5 = false
              var isZhiChi = false
              var notLeadoo = false // 不会触发leadoo的路由
              debugger
              if (
                window.location.pathname === '/oiq' ||
                window.location.pathname === '/oiq/start' ||
                window.location.pathname.indexOf('/lab') > -1
              ) {
                notLeadoo = true
              }
              const ticViewList = res.filter((v) => {
                return v.groupName === 'VIEW'
              })
              const BBCList = res.filter((v) => {
                return v.groupName === 'BBC'
              })
              const memberWebList = res.filter((v) => {
                return v.groupName === 'ME'
              })
              if (
                window.location.host === 'member.sgsonline.com.cn' ||
                window.location.host === 'memberuat.sgsonline.com.cn'
              ) {
                memberWebList.forEach((v) => {
                  if (v.paraValue === '1') {
                    if (v.paraCode.includes('KF5')) isKf5 = true
                    if (v.paraCode.includes('LEADOO')) isLeadoo = true
                    if (v.paraCode.includes('SOBOT')) isZhiChi = true
                  }
                })
              }
              if (
                window.location.host === 'store.sgsonline.com.cn' ||
                window.location.host === 'ticuat.sgsonline.com.cn'
              ) {
                BBCList.forEach((v) => {
                  if (v.paraValue === '1') {
                    if (v.paraCode.includes('KF5')) isKf5 = true
                    if (v.paraCode.includes('LEADOO')) isLeadoo = true
                    if (v.paraCode.includes('SOBOT')) isZhiChi = true
                  }
                })
              }
              // || window.location.host === "localhost:9501"
              if (
                window.location.host === 'www.sgsonline.com.cn' ||
                window.location.host === 'cmsuat.sgsonline.com.cn'
              ) {
                ticViewList.forEach((v) => {
                  if (v.paraValue === '1') {
                    if (v.paraCode.includes('KF5')) isKf5 = true
                    if (v.paraCode.includes('LEADOO')) isLeadoo = true
                    if (v.paraCode.includes('SOBOT')) isZhiChi = true
                  }
                })
              }
              if (notLeadoo) {
                $('#zc__sdk__sys__btn').trigger('click')
              } else {
                if (isKf5) {
                  $('#kf5-support-btn').trigger('click')
                } else if (isZhiChi) {
                  $('#zc__sdk__sys__btn').trigger('click')
                } else if (isLeadoo) {
                  var iframeLen = $('iframe').length
                  for (var i = 0; i < iframeLen; i++) {
                    if ($('iframe')[i]) {
                      $($('iframe')[i])
                        .contents()
                        .find('.ld-launch-btn')
                        .trigger('click')
                    }
                  }
                }
              }
            },
          })
        })

      /*
      TIC-5202
      数据模型： 站点.页面.模块.标识位.session
      实例化后：spm=EJHxGX9b.h.n-${id}.${collectCode}.${sessionId}&token=${token}
      a:EJHxGX9b 站点名称 ticView(EJHxGX9b) member(HNCO2i11) store(Y0tCOIDS)
      b:1YCEZc6a(home首页) M3nTPXTW(inner)内页 网站页面
      c:n-${id} (navication)导航的菜单服务或行业id
      d:${collectCode} 服务端唯一标识
      e:${sessionId} sessionid
      token: 登录后用户token
    */
      $('#serviceHome, #tradeHome').on('click', 'a', function (e) {
        if (e && e.preventDefault) {
          e.preventDefault()
        } else {
          window.event.returnValue = false
        }
        var href = $(this).attr('href')
        var link = $(this).data('link')
        var collectcode = ''
        var id = ''
        if ($(this).data('collectcode'))
          collectcode = $(this).data('collectcode')
        if ($(this).data('id')) id = '-' + $(this).data('id')
        if (link) {
          createSPM('M3nTPXTW', id, collectcode, 'sessionId')
          window.location.href = ticViewUrl + link
        } else {
          createSPM('M3nTPXTW', id, collectcode, 'sessionId')
          window.location.href = href
        }
      })
      function createSPM(b, c, d, e) {
        var website = 'EJHxGX9b'
        var pageCode = ''
        var token = ''
        if (origin.indexOf('member') > -1) {
          website = 'HNCO2i11'
          token = ''
        } else if (origin.indexOf('store') > -1) {
          website = 'Y0tCOIDS'
          token = ''
        } else {
          token = ''
        }
        var spm = [website, b, 'n' + c, d, e]
        var query = {
          spm: spm.join('.'),
          token: token,
          tx: '',
        }
        $.ajax({
          type: 'POST',
          url: ticViewUrl + 'sendSPM',
          // url: 'http://localhost:9501/sendSPM',
          data: query,
          success: function (res) { },
          fail: function (data) { },
          complete: function (complete) { },
        })
      }
    },
  },
  mounted() {
    console.log($)
    searchHotWord({}, this.host.nodeUrl).then((res) => {
      if (res) this.hotWords = res.data.items
    })
    qryNavi({}, this.host.nodeUrl).then((res) => {
      if (res) {
        this.services = res.data.services
        this.trades = res.data.trades
        this.informations = res.data.informations
        var serviceID = $('#serviceNav'),
          tradeID = $('#tradeNav'),
          serviceNavication = res.data.services,
          tradeNavication = res.data.trades
        console.log(serviceID, tradeID)
        //　服务菜单
        if (serviceNavication.length) {
          this.renderNavicationInner(serviceNavication, serviceID, '/service/')
        }
        // 行业菜单
        if (tradeNavication.length) {
          this.renderNavicationInner(tradeNavication, tradeID, '/industry/')
        }
      }
    })
  },
}
</script>

<style lang='scss'>
@import './../../assets/style/mixin.scss';

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.navwrap {
  height: 100px;
  background: #fff;
}

.navwrap * {
  box-sizing: content-box;
}

.navBox {
  width: 1226px;
  margin: 0 auto;
  background: white;
  position: relative;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav {
  width: 100%;
  height: 0;
  margin: 0 auto;
  background: #ffffff;
}

.nav.fix {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 12000;
  height: 100px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.navwrap {
  height: 100px;
  background: #fff;
}

.navUl {
  float: left;
  width: auto;
  height: 100%;
  margin-left: 50px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}

.navLi {
  width: auto;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: #333333;
  float: left;
  position: relative;
  cursor: pointer;
  text-align: center;
  margin: 0 25px;
  list-style: none;
}

.navLi a {
  color: #333333;
}

.navLi a:hover {
  color: $mainColor;
  font-weight: bold;
}

.navLi.s:hover {
  color: $mainColor;
  font-weight: bold;
}

.navLi.t {
  margin-right: 0;
}

.navLi.t:hover {
  color: $mainColor;
  font-weight: bold;
}

.navBor {
  position: absolute;
  width: 1px;
  background: #eeeeee;
  height: auto;
  top: 10px;
  left: 200px;
}

.navImg {
  width: 113px;
  height: 53px;
  margin-top: 24px;
  float: left;
  padding-bottom: 20px;
}

.navImg img {
  width: 100%;
  height: 100%;
}

.detailNav {
  border-bottom: 1px solid #eeeeee;
  height: 100px;
  overflow: visible;
}

.navList {
  float: left;
}

.navList>ul {
  float: left;
  width: auto;
  height: 100%;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  margin-left: 55px;
}

.mainNav>li {
  width: auto;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: rgb(51, 51, 51);
  float: left;
  cursor: pointer;
  text-align: center;
  list-style: none;
  position: relative;
}

.mainNav>li>a,
.mainNav>li>span {
  color: rgb(51, 51, 51);
  display: inline-block;
  padding: 0 15px;
}

.mainNav>li>a:hover,
.mainNav>li>span:hover {
  color: $mainColor;
  font-weight: bold;
}

#tradeNav,
#serviceNav {
  display: none;
}

.allNav * {
  padding: 0;
  margin: 0;
}

#tradeHome .allNav {
  left: -361px;
}

#serviceHome .allNav {
  left: -241px;
}

.allNav {
  height: 100px;
  width: 1226px;
  position: absolute;
  top: 100px;
  left: 0px;
  z-index: 1100;
  border-top: 4px solid $mainColor;
  min-height: 468px;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
}

.allNav .side li.active a.cursorDefault {
  cursor: default;
}

.allNav li {
  list-style: none;
}

.allNav .side {
  float: left;
  width: 230px;
  background: rgba(75, 75, 75, 1);
  height: 100%;
}

.allNav .side li {
  height: 36px;
  line-height: 36px;
  text-align: left;
}

.allNav .side li:hover,
.allNav .side li.active {
  background: #fff;
}

.allNav .side li:hover a,
.allNav .side li.active a {
  color: $mainColor;
  cursor: pointer;
  font-weight: bold;
}

.allNav .side a {
  color: #fff;
  font-size: 15px;
  padding-left: 30px;
  display: inline-block;
  height: 24px;
  line-height: 24px;
}

.allNav .main {
  background: #fff;
  height: 468px;
  float: left;
  width: 966px;
  padding: 0 30px 0 0;
  overflow: hidden;
  position: relative;
}

.allNav .main .list {
  display: none;
  width: 996px;
  height: 468px;
  overflow-y: auto;
}

.main-list {
  min-height: 277px;
}

.main-list2 {
  min-height: 275px;
}

.allNav .main .list.active {
  display: block;
}

.allNav .main .list dl {
  border-bottom: 1px dashed #999;
  padding-bottom: 15px;
  margin: 0 30px;
}

.allNav .main .list dl:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.allNav .main .list dt {
  text-align: left;
  padding: 15px 0 0 0;
  height: 20px;
  line-height: 20px;
  clear: both;
}

.allNav .main .list dt span {
  background: #4b4b4b;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  display: block;
  margin-top: 8px;
  float: left;
  color: #fff;
}

.allNav .main .list dt a,
.allNav .main .list dt em {
  color: #4b4b4b;
  font-size: 14px;
  display: block;
  float: left;
  padding-left: 5px;
  font-style: normal;
}

.allNav .main .list dt em.cursorDefault {
  cursor: default;
}

.allNav .main .list dd {
  float: left;
  height: 20px;
  line-height: 20px;
  padding-top: 10px;
  text-align: left;
  margin: 0;
  margin-right: 20px;
  padding-left: 10px;
}

.allNav .main .list dd a {
  color: #999;
  font-size: 14px;
}

.allNav .main .list a:hover {
  color: $mainColor;
}

.allNav .main .list dd i {
  width: 20px;
  height: 14px;
  display: inline-block;
  background: url(./../../assets/images/portal/nav-hot.png) no-repeat 0 0;
}

.allNav .main .second {
  float: left;
  width: 233px;
  background: #f5f5f5;
  height: 468px;
  position: absolute;
  top: 0;
  left: 0;
}

.allNav .main .second li {
  height: 36px;
  line-height: 36px;
  text-align: left;
}

.allNav .main .second li.active,
.allNav .main .second li:hover {
  background: #fff;
}

.allNav .main .second li.active a,
.allNav .main .second li:hover a {
  border-left: 4px solid $mainColor;
}

.allNav .main .second li a {
  color: #4b4b4b;
  font-size: 15px;
  display: inline-block;
  height: 16px;
  line-height: 16px;
  border-left: 4px solid #f5f5f5;
  padding-left: 30px;
}

.allNav .main .secondList {
  width: 690px;
  float: right;
  height: 468px;
  padding: 0 30px;
}

.allNav .main .secondList li {
  display: none;
  width: 100%;
  clear: both;
  padding-top: 10px;
}

.allNav .main .secondList li.active {
  display: block;
}

.allNav .main .secondList p {
  text-align: left;
  color: #4b4b4b;
  font-size: 15px;
  clear: both;
  height: 24px;
  line-height: 24px;
  padding-top: 10px;
}

.allNav .main .secondList .main-list2 p {
  cursor: default;
}

.allNav .main .secondList p:first-child {
  padding-top: 0;
}

.allNav .main .secondList span {
  height: 25px;
  line-height: 25px;
  padding-top: 5px;
  text-align: left;
  margin: 0;
  padding-right: 30px;
  float: left;
}

.allNav .main .secondList i {
  width: 20px;
  height: 14px;
  display: inline-block;
  background: url(./../../assets/images/portal/nav-hot.png) no-repeat 0 0;
}

.allNav .main .secondList li a {
  color: #999;
  font-size: 14px;
}

.allNav .ads {
  margin: 0 30px;
}

.allNav .secondList .ads {
  margin: 0;
}

.allNav .secondList .ads.ads-mt {
  margin-top: -81px;
}

.allNav .main .secondList .ads ul {
  width: 690px;
  height: 100px;
  overflow: hidden;
  margin-bottom: 20px;
}

.allNav .main .secondList .ads li {
  display: block;
  clear: none;
  width: 321px;
}

.allNav .main .secondList .ads li img {
  width: 146px;
  height: 72px;
  margin-right: 10px;
}

.allNav .main .secondList .ads li .info {
  width: 165px;
  height: 72px;
}

.allNav .main .secondList .ads li h3 {
  width: 165px;
}

.allNav .main .secondList .ads li p {
  color: #999;
  width: 165px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  height: 14px;
  line-height: 14px;
  text-align: left;
  margin-top: 3px;
  padding: 0;
}

.allNav .main .secondList .ads li em,
.allNav .main .secondList .ads li button {
  color: #fff;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  margin-top: 12px;
}

.allNav .moreService {
  text-align: right;
  border-bottom: 1px dashed #999;
  padding: 10px 0;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 9px 0;
}

.allNav .moreService {
  text-align: right;
  border-bottom: 1px dashed #999;
  padding: 10px 0;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 9px 0;
}

.allNav .moreService i {
  display: inline-block;
  width: 15px;
  height: 10px;
  background: url(./../../assets/images/portal/nav-more.png) no-repeat 0 0;
}

.allNav .secondList .moreService i {
  display: inline-block;
  width: 15px;
  height: 10px;
  background: url(./../../assets/images/portal/nav-more.png) no-repeat 0 0;
}

.allNav .moreService a {
  color: $mainColor;
}

.allNav .main .secondList li a.moreServiceA {
  color: $mainColor;
}

.allNav .ads ul {
  padding-bottom: 20px;
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.allNav .ads li {
  float: left;
  margin-top: 20px;
}

.allNav .ads li:nth-child(even) {
  float: right;
}

.allNav .ads img {
  width: 180px;
  height: 90px;
  float: left;
  margin-right: 10px;
}

.allNav .ads .mini img {
  width: 146px;
  height: 72px;
  margin-right: 10px;
}

.allNav .ads .info {
  float: right;
  width: 240px;
  height: 90px;
}

.allNav .ads .mini .info {
  height: 72px;
}

.allNav .ads h3 {
  width: 240px;
  font-size: 16px;
  color: #252525;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 18px;
  line-height: 18px;
  text-align: left;
}

.allNav .ads h3:hover {
  color: $mainColor;
}

.allNav .ads p {
  color: #999;
  width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  height: 14px;
  line-height: 14px;
  text-align: left;
  margin-top: 3px;
}

.allNav .ads li button,
.allNav .ads li em {
  font-size: 15px;
  color: #fff;
  border: 0;
  outline: 0;
  background: $mainColor;
  cursor: pointer;
  display: block;
  width: 90px;
  height: 34px;
  line-height: 34px;
  margin-top: 21px;
  float: left;
  font-style: normal;
}

.allNav .ads .mini li button,
.allNav .ads .mini li em {
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  margin-top: 13px;
  display: block;
  font-style: normal;
}

.allNav .ads li em:hover,
.allNav .ads .mini li em:hover {
  color: #fff;
  background: #fe7427;
}

.navSearchBox {
  height: 46px;
  float: right;
  position: relative;
  width: 400px;
  right: 0;
  top: 0;
}

.navSearchBox .hotKeyword {
  position: absolute;
  right: 50px;
  top: 13px;
}

.navSearchBox .hotKeyword a {
  background: #ddd;
  color: #fff;
  padding: 0 5px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
  margin-right: 3px;
  height: 20px;
  line-height: 20px;
}

.navSearchBox .hotKeyword a:hover {
  background: #ca4300;
}

.navSearchBox .linkageWord {
  position: absolute;
  top: 45px;
  left: 0;
  border: 1px solid #ca4300;
  width: 398px;
  z-index: 12;
  background: #fff;
}

.navSearchBox .linkageWord ul {
  padding: 5px 0;
  margin: 0;
}

.navSearchBox .linkageWord li {
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  list-style: none;
  padding-left: 15px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 370px;
}

.navSearchBox .linkageWord li:hover {
  background: #f5f5f5;
}

.navSearchBox form {
  width: 100%;
  height: 100%;
}

.navSearch {
  width: 342px;
  height: 40px;
  border: none;
  outline: none;
  border: 1px solid #ca4300;
  float: right;
  padding: 2px 0 2px 10px;
  font-size: 16px;
  line-height: 40px;
}

.navSearchBox button {
  width: 46px;
  height: 46px;
  background: #ca4300;
  float: right;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border: 0;
}

.navSearchIconIcon {
  width: 20px;
  height: 20px;
  background: url(./../../assets/images/portal/search.png) no-repeat 50% 50%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.navImg,
.navSearch {
  box-sizing: content-box;
}

.nav_first--li {
  position: relative;
}

.nav_first--li .nav_second {
  background: #333333;
  position: absolute;
  top: 84px;
  left: -17px;
  z-index: 12;
  width: 150px;
  display: none;
  border-top: 4px solid $mainColor;
}

.nav_first--li .nav_second dd {
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin: 0;
}

.nav_first--li .nav_second dd a {
  color: #fff;
  display: inline-block;
  height: 35px;
  line-height: 35px;
  width: 100%;
}

.nav_first--li .nav_second dd a:hover {
  background: #fff;
  color: $mainColor;
  font-weight: bold;
}

.dragAngel {
  width: 0;
  height: 0;
  position: absolute;
  overflow: hidden;
  font-size: 0;
  line-height: 0px;
  border-width: 0px 10px 11px;
  border-style: solid solid solid solid;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  border-bottom-color: $mainColor;
  display: none;
  left: 44px;
  top: 89px;
}

.navSearchBox button {
  box-sizing: border-box;
}
</style>